<template>
  <div id="wrapper" :class="toggle">
    <div id="sidebar-wrapper">
      <ul class="sidebar-nav">
        <li class="sidebar-brand">
          <router-link to="/">
            <img height="28" :src="logo" />
          </router-link>
        </li>
        <li class="border-bottom border-top">
          <h4 class="text-white mt-2">{{bot.first_name}}</h4>
        </li>
        <li>
          <a href="#" @click="navigate('chats')">CHATS</a>
        </li>
        <li>
          <a href="#" @click="navigate('commands')">COMMANDS</a>
        </li>
        <li>
          <a href="#" @click="navigate('reply buttons')">REPLY BUTTONS</a>
        </li>
        <li>
          <a href="#" @click="navigate('inline buttons')">INLINE BUTTONS</a>
        </li>
        <li>
          <a href="#" @click="navigate('keywords')">KEYWORDS</a>
        </li>
        <li>
          <a href="#" @click="navigate('schedule')">SCHEDULE</a>
        </li>
        <li>
          <a href="#" @click="navigate('variables')">VARIABLES</a>
        </li>
        <li>
          <a href="#" @click="navigate('magic variables')">MAGIC VARIABLES</a>
        </li>
        <li>
          <a href="#" @click="navigate('my templates')">MY TEMPLATES</a>
        </li>
        <li>
          <a href="#" @click="$router.push({name: 'dashboard',params: { propToken: token }})">DASHBOARD</a>
        </li>
      </ul>
    </div>
    <div class="page-content-wrapper">
      <div class="container-fluid">
        <div class="row mb-2 border-bottom border-info">
          <div class="col-xs-2">
            <a
              class="btn btn-link p-2"
              style="font-size: 1.5rem;color: #007bff;background-color: transparent;"
              role="button"
              id="menu-toggle"
              @click="toggle=toggle==null?'toggled':null"
            >
              <i class="fa fa-bars"></i>
            </a>
          </div>
          <div class="col-xs-10">
            <h1 class="p-2">{{show}}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <loading :active.sync="isLoading" :can-cancel="true" color="green"></loading>

            <div class="container mb-5 px-0" v-if="show=='new chat'">
              <ChatName
                :current_chat="current_chat"
                @changeCurrentChat="changeCurrentChat"
                ref="chatname"
              ></ChatName>
              <div
                v-for="(event,index) in events"
                :key="index"
                class="shadow mb-3 p-2 bg-white border border-info"
              >
                <button
                  @click="removeAction(index)"
                  type="button"
                  class="btn btn-outline-danger btn-block mb-3"
                >Delete This Action</button>
                <Task :tasks="event.tasks" :actions="actions"></Task>
              </div>
              <div class="btn-group btn-group-justified w-100 mb-5">
                <button class="btn btn-outline-info btn-block m-0" @click="addAction">Add Action</button>
                <button class="btn btn-outline-info btn-block m-0" @click="saveChat">Save Chat</button>
              </div>
            </div>

            <div class="container mb-5 px-0" v-if="show=='edit chat'">
              <ChatName
                :current_chat="current_chat"
                @changeCurrentChat="changeCurrentChat"
                ref="chatname"
              ></ChatName>
              <div
                v-for="(event,index) in events"
                :key="index"
                class="shadow mb-3 p-2 bg-white border border-info"
              >
                <div class="btn-group btn-group-justified w-100 mb-3">
                  <button @click="moveActionUp(index)" class="btn btn-sm btn-outline-secondary" title="Move Up">
                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                  </button>
                  <button @click="removeAction(index)" type="button" class="btn btn-outline-danger btn-block">
                    Delete This Action
                  </button>
                  <button @click="moveActionDown(index)" class="btn btn-sm btn-outline-secondary" title="Move Down">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                  </button>
              </div>
                <Task :tasks="event.tasks" :actions="actions"></Task>
              </div>
              <div class="btn-group btn-group-justified w-100 mb-5">
                <button class="btn btn-outline-info btn-block m-0" @click="addAction">Add Action</button>
                <button class="btn btn-outline-info btn-block m-0" @click="saveChat">Save Chat</button>
              </div>
            </div>

            <div class="container mb-5 px-0" v-if="show=='chats'">
              <Chats :chat_names="chat_names" @editChat="editChat" @removeChat="removeChat" @copyChat="copyChat"></Chats>
              <button class="btn btn-outline-info btn-block mb-3" @click="newChat">Create New Chat</button>
            </div>

            <div class="container mb-5 px-0" v-if="show=='commands'">
              <Commands
                :commands="actions.commands"
                :chat_names="chat_names"
                @removeCommand="removeCommand"
                @addCommand="addCommand"
              ></Commands>
            </div>

            <div class="container mb-5 px-0" v-if="show=='reply buttons'">
              <ReplyButtons :reply_buttons="actions.reply_buttons" :chat_names="chat_names"></ReplyButtons>
            </div>

            <div class="container mb-5 px-0" v-if="show=='inline buttons'">
              <Callbacks :callbacks="actions.callbacks" :chat_names="chat_names"></Callbacks>
            </div>

            <div class="container mb-5 px-0" v-if="show=='keywords'">
              <Keywords
                :keywords="actions.keywords"
                :chat_names="chat_names"
                @addKeyword="addKeyword"
                @removeKeyword="removeKeyword"
              ></Keywords>
            </div>

            <div class="container mb-5 px-0" v-if="show=='schedule'">
              <Schedule
                :schedules="actions.schedules"
                :chat_names="chat_names"
                @addSchedule="addSchedule"
                @removeSchedule="removeSchedule"
              ></Schedule>
            </div>

            <div class="container mb-5 px-0" v-if="show=='variables'">
              <Variables
                :variables="variables"
                @addVariable="addVariable"
                @removeVariable="removeVariable"
                @removeVariableValue="removeVariableValue"
                @addVariableValue="addVariableValue"
              ></Variables>
            </div>

            <div class="container mb-5 px-0" v-if="show=='magic variables'">
              <p>
                <a
                  href="/user-guide#Magic-Variables"
                  target="_blank"
                  rel="noopener noreferrer"
                >Read more about Magic variables here</a>
              </p>
              <MagicVariables></MagicVariables>
            </div>

            <div class="container mb-5 px-0" v-if="show=='my templates'">
              <MyTemplates @update="templateUpdate" :currentBot="bot"></MyTemplates>
            </div>

            <button @click="updateBot" class="btn btn-success fixed-bottom btn-block">Update Bot</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import Commands from "@/components/Commands.vue";
import ReplyButtons from "@/components/ReplyButtons.vue";
import Callbacks from "@/components/Callbacks.vue";
import Keywords from "@/components/Keywords.vue";
import Schedule from "@/components/Schedule.vue";
import Variables from "@/components/Variables.vue";
import MagicVariables from "@/components/MagicVariables.vue";
import MyTemplates from "@/components/MyTemplates.vue";
import Chats from "@/components/Chats.vue";
import ChatName from "@/components/ChatName.vue";
import Task from "@/components/Task.vue";

import ApiService from "@/services/ApiService";
import TelegramService from '@/services/TelegramService'

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import logo from "@/assets/img/logo-white-text.png";

export default {
  name: "Editor",
  components: {
    Commands,
    ReplyButtons,
    Callbacks,
    Keywords,
    Schedule,
    Variables,
    MagicVariables,
    MyTemplates,
    Chats,
    ChatName,
    Task,
    Loading
  },
  props: {
    token: String
  },
  data: function() {
    return {
      show: "commands",
      logo: logo,
      toggle: null,
      isLoading: false,
      user: this.$store.state.user,
      bot: {},
      nameError: "",
      chat_names: [],
      current_chat: "",
      events: [],
      chats: {},
      actions: {
        commands: [],
        callbacks: [],
        reply_buttons: [],
        keywords: [],
        schedules: []
      },
      action_stack:{add:{reply_buttons:[], callbacks:[]}, remove:{reply_buttons:[], callbacks:[]}},
      variables: []
    };
  },
  methods: {
    templateUpdate(){
      this.getBot(this.token)
      this.navigate('chats')
    },

    navigate: async function(to){
      if(this.show == 'edit chat' || this.show == 'new chat'){
        if(await this.saveChat()){
          this.show = to
          this.toggle = null
        }
      }else{
        this.show = to
        this.toggle = null
      }
      
    },

    removeCommand: function(index) {
      this.actions.commands.splice(index, 1);
    },

    addCommand: function() {
      this.actions.commands.push({
        command: null,
        chat: null,
        description: null,
        admin: false,
        prime: false,
        error: false
      });
    },

    removeKeyword: function(index) {
      this.actions.keywords.splice(index, 1);
    },

    addKeyword: function() {
      this.actions.keywords.push({
        keyword: null,
        chat: null
      });
    },

    removeSchedule: function(index) {
      this.actions.schedules.splice(index, 1);
    },

    addSchedule: function() {
      this.actions.schedules.push({
        occurrenceType: "Minute",
        occurrenceInterval: 5,
        occurrenceTime:{
          month_day: null,
          week_day: null,
          hour: null,
          minute: null
        },
        chat_name: null        
      });
    },

    addVariable: function(type) {
      let v = null;
      if(type == 'multiple'){
        v = ["",""]
      }
      this.variables.push({
        variable: null,
        value: v,
        type: type
      });
    },

    addVariableValue: function(index) {
      this.variables[index].value.push("");
    },

    removeVariable: function(index) {
      this.variables.splice(index, 1);
    },

    removeVariableValue: function(index, i) {
      this.variables[index].value.splice(i, 1);
    },

    getVariables: function() {
      let variables = {};
      for (let index = 0; index < this.variables.length; index++) {
        let element = this.variables[index];
        variables[element.variable] = element.value;
      }
      return variables;
    },

    loadVariables: function(variables) {
      Object.keys(variables).forEach(
        function(key) {
          this.variables.push({ variable: key, value: variables[key] });
        }.bind(this)
      );
    },

    editChat: function(index) {
      this.navigate('edit chat')
      this.current_chat = this.chat_names[index];
      this.events = this.chats[this.current_chat].events;
      delete this.chats[this.current_chat];
      this.chat_names.splice(index, 1);
    },

    removeChat: function(index) {
      this.$dialog
        .confirm("If you Delete This Chat, It'll Be Gone Forever.")
        .then(
          function() {
            var chatname = this.chat_names[index];
            this.removeButtonsInChat(this.chats[chatname]);
            this.chat_names.splice(index, 1);
            delete this.chats[chatname];
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    },

    copyChat: function(index) {
      let chatname = this.chat_names[index];
      let chat = this.chats[chatname];
      let newChatname = chatname+' copy'
      this.chats[newChatname] = JSON.parse(JSON.stringify(chat))
      if (!this.chat_names.includes(newChatname)) {
        this.chat_names.push(newChatname);
      }
    },

    changeCurrentChat: function(chat) {
      this.current_chat = chat;
    },

    newChat: function() {
      this.navigate("new chat");
      let n = this.chat_names.length+1
      this.current_chat = "chat "+n;
      this.events = [];
    },

    addAction: function() {
      this.events.push({
        tasks: []
      });
    },

    removeAction: function(index) { 
      this.removeButtonsInAction(this.events[index])
      this.events.splice(index, 1);
    },

    moveActionUp: function(index) {
      if(index != 0){
        let upper_action = this.events[index-1]
        Vue.set(this.events, index-1, this.events[index])
        Vue.set(this.events, index, upper_action)
      }
    },
    moveActionDown: function(index) {
      if(index != this.events.length-1){
        let down_action = this.events[index+1]
        Vue.set(this.events, index+1, this.events[index])
        Vue.set(this.events, index, down_action)
      }
    },

    removeButtonsInTask: function(task) {
      var res = this.getBtnsAndCallbacksInTask(task)
      res.btns.forEach(
        function(btn) {
          this.actions.reply_buttons = this.actions.reply_buttons.filter(
            function(value) {
              return  value.button.id != btn.id;
            }.bind(this)
          );
        }.bind(this)
      );
      res.clbks.forEach(
        function(btn) {
          this.actions.callbacks = this.actions.callbacks.filter(
            function(value) {
              return (
                value.button.id != btn.id
              );
            }.bind(this)
          );
        }.bind(this)
      );
    },

    removeButtonsInAction: function(event){
      for (var j = 0; j < event.tasks.length; j++) {
        this.removeButtonsInTask(event.tasks[j]);
      }
    },

    removeButtonsInChat: function(chat){
      for (var j = 0; j < chat.events.length; j++) {
        this.removeButtonsInAction(chat.events[j]);
      }
    },

    deleteOldButtons(oldChat, newChat) {
      var oldres = this.getBtnsAndCallbacksInChat(oldChat);
      var newres = this.getBtnsAndCallbacksInChat(newChat);
      oldres.btns.forEach(
        function(oldbtn) {
          if (!includes(oldbtn, newres.btns)) {
            this.actions.reply_buttons = this.actions.reply_buttons.filter(
              function(value) {
                return value.button.id != oldbtn.id;
              }.bind(this)
            );
          }
        }.bind(this)
      );

      oldres.clbks.forEach(
        function(oldbtn) {
          if (!includes(oldbtn, newres.clbks)) {
            this.actions.callbacks = this.actions.callbacks.filter(
              function(value) {
                return value.button.id != oldbtn.id;
              }.bind(this)
            );
          }
        }.bind(this)
      );

      function includes(btn, btns) {
        for (var j = 0; j < btns.length; j++) {
          if (btn.id == btns[j].id) {
            return true;
          }
        }
        return false;
      }
    },

    getBtnsAndCallbacksInTask(task) {
      var btns = [];
      var clbks = [];
      if ("reply_markup" in task.data && task.data.reply_markup != null) {
        if ("keyboard" in task.data.reply_markup) {
          let keyboard = task.data.reply_markup.keyboard;
          for (var k = 0; k < keyboard.length; k++) {
            for (var l = 0; l < keyboard[k].length; l++) {
              btns.push(keyboard[k][l]);
            }
          }
        }
        if ("inline_keyboard" in task.data.reply_markup) {
          let inline_keyboard = task.data.reply_markup.inline_keyboard;
          for (k = 0; k < inline_keyboard.length; k++) {
            for (l = 0; l < inline_keyboard[k].length; l++) {
              if (inline_keyboard[k][l].type == "callback_data")
                clbks.push(inline_keyboard[k][l]);
            }
          }
        }
      }

      if('else_tasks' in task.data){
        task.data.else_tasks.forEach(function(else_task){
          var res = this.getBtnsAndCallbacksInTask(else_task)
          btns = btns.concat(res.btns)
          clbks = clbks.concat(res.clbks)
        }.bind(this));
      }

      return {
        btns: btns,
        clbks: clbks
      };
    },

    getBtnsAndCallbacksInAction(event){
      var btns = [];
      var clbks = [];
      for (var j = 0; j < event.tasks.length; j++) {
        var res = this.getBtnsAndCallbacksInTask(event.tasks[j])
        btns = btns.concat(res.btns)
        clbks = clbks.concat(res.clbks)
      }
      return {
        btns: btns,
        clbks: clbks
      };
    },

    getBtnsAndCallbacksInChat(chat) {
      var btns = [];
      var clbks = [];
      for (var i = 0; i < chat.events.length; i++) {
        var res = this.getBtnsAndCallbacksInAction(chat.events[i])
        btns = btns.concat(res.btns)
        clbks = clbks.concat(res.clbks) 
      }
      return {
        btns: btns,
        clbks: clbks
      };
    },

    saveChat: async function() {
      if (this.current_chat != null && this.current_chat.trim() != "") {
        let chat = {
          events: this.events
        };
        if (this.verifyChatFields(chat)) {
          // if chat name already present, confirm before proceed
          if (this.current_chat in this.chats) {
            let info = "Chat name "+this.current_chat+" alreday present, Saving this \
            chat with same name will over write old chat."
            try{
              let confirm = await this.$dialog.confirm(info)
              if(confirm){
                var oldChat = this.chats[this.current_chat];
                this.deleteOldButtons(oldChat, chat);
                this.chats[this.current_chat] = chat;
                if (!this.chat_names.includes(this.current_chat)) {
                  this.chat_names.push(this.current_chat);
                  this.chat_names.sort(function (a, b) {
                      return a.toLowerCase().localeCompare(b.toLowerCase());
                  });
                }
                this.events = [];
                this.current_chat = "";
                this.navigate('chats')
                return true;
              }
            }
            catch{
              this.$refs.chatname.$refs.input.focus();
              return false;
            }
          }else{
            this.chats[this.current_chat] = chat;
            if (!this.chat_names.includes(this.current_chat)) {
              this.chat_names.push(this.current_chat);
              this.chat_names.sort(function (a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
              });
            }
            this.events = [];
            this.current_chat = "";
            this.navigate('chats')
            return true
          }
        }
      } else {
        if(this.events.length == 0){
          return true
        }
        this.$dialog.alert("Chat Name Can Not Be Empty!").then(
          function() {
            this.$refs.chatname.$refs.input.focus();
            return false;
          }.bind(this)
        );
      }
    },

    verifyChatFields(chat) {
      var warning = "Fill all the fields in highlighted Task or Delete and try again."
      var IGNORE = ["reply_markup", "caption", "error"];
      let events = chat.events;
      for (var i = 0; i < events.length; i++) {
        let tasks = events[i].tasks;
        for (var j = 0; j < tasks.length; j++) {
          this.events[i].tasks[j].error = false;
          let data = JSON.parse(JSON.stringify(tasks[j].data));
          if ("reply_markup" in data && data.reply_markup != null) {
            if (!this.verify_reply_markup(data.reply_markup)) {
              console.log("Reply markup field verification failed")
              this.events[i].tasks[j].error = true;
              return false;
            }
          }
          IGNORE.forEach(function(key) {
            if (key in data) delete data[key];
          });

          if(this.check_if_empty_field(data) == false){
            this.events[i].tasks[j].error = true;
            this.$dialog.alert(warning);
            return false;
          }
         
        }
      }
      return true;
    },

    check_if_empty_field(data){
      var IGNORE = ["reply_markup", "caption", "error"];
      if (typeof data == "string") {
        if (data == undefined || data.trim() == "")
        {
          console.log("verification failed for "+data)
          return false
        }
        
      }
      else if (Array.isArray(data)) {
        for (var k = 0; k < data.length; k++) {
          if(this.check_if_empty_field(data[k]) == false)
            return false
        }
      }
      else if (typeof data == "object") {
        if (data == null) {
          console.log("verification failed for "+data)
          return false
        }
        else{
          IGNORE.forEach(function(key) {
            if (key in data) delete data[key];
          });
          for (var key in data) {
            if(this.check_if_empty_field(data[key]) == false){
              console.log("verification failed for "+key)
              return false
            }
          }
        }
      }
    },

    verify_reply_markup(reply_markup) {
      if ("keyboard" in reply_markup) {
        for (var i = 0; i < reply_markup.keyboard.length; i++) {
          let row = reply_markup.keyboard[i];
          for (var j = 0; j < row.length; j++) {
            let btn = row[j];
            if (btn.text == null || btn.text.trim() == "") {
              this.$dialog.alert(
                "Fill all Reply Button fields in highlighted Task and try again."
              );
              return false;
            }
          }
        }
      }
      if ("inline_keyboard" in reply_markup) {
        for (i = 0; i < reply_markup.inline_keyboard.length; i++) {
          let row = reply_markup.inline_keyboard[i];
          for (j = 0; j < row.length; j++) {
            let btn = row[j];
            let btype = btn.type;
            if (btn.text == null || btn.text.trim() == "") {
              this.$dialog.alert(
                "Fill all Inline Button fields in highlighted Task and try again."
              );
              return false;
            }
            if (btype == "login_url") {
              if (btn.login_url.url == null || btn.login_url.url.trim() == "") {
                this.$dialog.alert(
                  "Fill all Inline Button fields in highlighted Task and try again."
                );
                return false;
              }
            } else {
              if (btn[btype] == null || btn[btype].trim() == "") {
                this.$dialog.alert(
                  "Fill all Inline Button fields in highlighted Task and try again."
                );
                return false;
              }
            }
          }
        }
      }
      return true;
    },

    verify_command_fields(commands) {
      for (var i = 0; i < commands.length; i++) {
        commands[i].error = false;
        if (/^([a-z0-9_]{1,32})$/.test(commands[i].command) != true) {
          commands[i].error = true;
          this.navigate('commands')
          this.$dialog.alert(
            "'Command' should contain only lowercase English letters, numbers and underscores."
          );
          return false;
        }
        if (commands[i].command == null || commands[i].command.trim() == "") {
          commands[i].error = true;
          this.navigate('commands')
          this.$dialog.alert("'Command' field is empty in highlighted command");
          return false;
        }
        if (commands[i].chat == null || commands[i].chat.trim() == "") {
          commands[i].error = true;
          this.navigate('commands')
          this.$dialog.alert("'Chat' field is empty in highlighted command");
          return false;
        }
        if (
          commands[i].description == null ||
          commands[i].description.trim() == ""
        ) {
          commands[i].error = true;
          this.navigate('commands')
          this.$dialog.alert(
            "'Description' field is empty in highlighted command"
          );
          return false;
        }
        if (commands[i].description.length < 4) {
          commands[i].error = true;
          this.navigate('commands')
          this.$dialog.alert(
            "'Description' of a command should be more than 3 characters"
          );
          return false;
        }
      }
      return true;
    },

    updateBot: async function(){
      if(this.show == 'edit chat' || this.show == 'new chat'){
        let res = await this.saveChat();
        if(!res){
          return false;
        }
      }

      this.isLoading = true;
      let structure = {
        chats: this.chats,
        actions: this.actions,
        variables: this.getVariables()
      };

      ApiService.updateBot(this.user, this.token, structure)
        .then(
          function() {
            var cmds = this.actions.commands.filter(function(cmd) {
              return !cmd.admin
            })
            TelegramService.setMyCommands(this.token, {commands: cmds})
            .then(function() {
              this.$dialog.alert('Bot Updated Successfully!')
            }.bind(this))
            .catch(function(error) {
              this.$dialog.alert(error)
            }.bind(this))    
          }.bind(this)
        )
        .catch(
          function(response) {
            if (response.status_code != null) {
              this.$dialog.alert(response.description);
            } else {
              this.$dialog.alert("Unknown error occured, Please try after sometime.");
            }
          }.bind(this)
        )
        .finally(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },

    async getBot(token) {
      this.isLoading = true;
      ApiService.getBot(this.user, token)
        .then(
          function(result) {
            this.chats = result.structure.chats;
            // Hack for keyword update, remove later
            let actions = result.structure.actions;
            if (!("keywords" in actions)) {
              actions["keywords"] = [];
            }
            if (!("schedules" in actions)) {
              actions["schedules"] = [];
            }
            this.actions = actions;
            this.chat_names = Object.keys(this.chats);
            this.chat_names.sort(function (a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.loadVariables(result.structure.variables);
          }.bind(this)
        )
        .catch(
          function(response) {
            this.$dialog.alert(response.description);
          }.bind(this)
        )
        .finally(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },

    async getMe(token) {
      TelegramService.getMe(token)
        .then(function(bot) {
          bot['token'] = token
          this.bot = bot
        }.bind(this))
        .catch(function(error) {
          this.$dialog.alert(error)
          this.nameError = "Bot name not found"
        }.bind(this))
    }

  },

  mounted: function() {
    this.getMe(this.token)
    this.getBot(this.token);
  }
};
</script>
